import { useParams, Link } from "react-router-dom";

const DOCS = {
  termos: {
    title: "Termos de Uso",
    body: [
      "Este site contém material adulto sexualmente explícito, destinado exclusivamente a pessoas com 18 anos ou mais, ou com a maioridade legal da sua jurisdição.",
      "Ao acessar, você declara ser maior de idade, que o acesso a esse tipo de conteúdo é legal no local onde está e que não permitirá o acesso de menores.",
      "Todo o conteúdo é publicado exclusivamente pelo administrador. É proibido copiar, redistribuir ou revender o material sem autorização.",
      "O administrador pode alterar, remover ou suspender qualquer conteúdo a qualquer momento, sem aviso prévio.",
      "Para remoção de conteúdo ou denúncias, entre em contato pelo e-mail: [email de contato].",
    ],
  },
  privacidade: {
    title: "Política de Privacidade",
    body: [
      "Visitantes não precisam criar conta. Não coletamos nome, e-mail ou documentos de visitantes.",
      "Guardamos no seu navegador (localStorage) apenas a confirmação de que você é maior de 18 anos, para não repetir o aviso.",
      "Registramos contagens anônimas de visualizações por vídeo e foto, sem vincular a nenhuma pessoa.",
      "O login do administrador é feito via Google e serve apenas para gerenciar o conteúdo.",
      "Dúvidas sobre privacidade (LGPD): [email de contato].",
    ],
  },
  "2257": {
    title: "Aviso Legal 18+ / 18 U.S.C. 2257",
    body: [
      "Todas as pessoas que aparecem em qualquer conteúdo deste site tinham 18 anos ou mais no momento da produção.",
      "O administrador mantém os registros de idade e consentimento exigidos por lei para todo o material publicado.",
      "Este site tem tolerância zero com qualquer material envolvendo menores ou conteúdo não consensual. Qualquer denúncia será analisada e, se procedente, o conteúdo será removido imediatamente e reportado às autoridades.",
      "Custodiante dos registros: [nome e endereço do responsável].",
      "Este site é rotulado com RTA (Restricted To Adults) para facilitar o bloqueio por ferramentas de controle parental.",
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const doc = DOCS[slug] || DOCS.termos;
  return (
    <div className="mx-auto max-w-3xl px-5 pt-36 sm:px-10" data-testid={`legal-page-${slug}`}>
      <p className="eyebrow mb-4">Legal</p>
      <h1 className="font-serif-d mb-12 text-4xl font-semibold tracking-tight text-white sm:text-6xl">{doc.title}</h1>
      <ol className="space-y-6">
        {doc.body.map((p, i) => (
          <li key={i} className="flex gap-6 border-t border-white/5 pt-6 leading-relaxed text-slate-300">
            <span className="font-mono-d text-xs text-rose-400">{String(i + 1).padStart(2, "0")}</span>
            <span>{p}</span>
          </li>
        ))}
      </ol>
      <div className="mt-12 flex flex-wrap gap-6 text-sm">
        {Object.entries(DOCS).map(([k, d]) => (
          <Link key={k} to={`/legal/${k}`} className="text-slate-400 hover:text-rose-400" data-testid={`legal-nav-${k}`}>{d.title}</Link>
        ))}
      </div>
    </div>
  );
}
